import { HubioCommonPagesModule } from '@hubio/hubio-common-components';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { CdkStepperModule } from '@angular/cdk/stepper'
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BearerTokenInterceptor, HubioLoginModule, JwtInterceptor } from '@hubio/hubio-login';
import { environment } from 'src/environments/environment';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ConfigManagerModule } from './modules/config-manager/config-manager.module';
import { HeaderComponent } from '@core/components/header/header.component';
import { FooterComponent } from '@core/components/footer/footer.component';
import { ErrorNotFoundComponent } from '@core/components/error-not-found/error-not-found.component';
import { LoadingScreenComponent } from '@core/components/loading-screen/loading-screen.component';
import { HubioHttpInterceptor } from '@core/interceptors/http.interceptor';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Communic8DownloadModule } from './modules/communic8-download/communic8-download.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NavigationService } from '@core/services/navigation.service';
import { DropdownTabsComponent } from './core/components/dropdown-tabs/dropdown-tabs.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    ErrorNotFoundComponent,
    HeaderComponent,
    FooterComponent,
    LoadingScreenComponent,
    DropdownTabsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HubioLoginModule.forRoot(environment, new NavigationService()),
    HubioCommonPagesModule.forRoot(environment),
    BrowserAnimationsModule,
    MatCardModule,
    CdkStepperModule,
    MatMenuModule,
    MatIconModule,
    ConfigManagerModule,
    Communic8DownloadModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatSidenavModule,
    MatSelectModule,
    MatTooltipModule,
    MatSnackBarModule
  ],
  exports: [
    
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BearerTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HubioHttpInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
